// Array of 100 Muslim girl names
const DUMMY_GIRL_NAMES = [
  "Aisha",
  "Fatima",
  "Zainab",
  "Maryam",
  "Khadija",
  "Hafsa",
  "Aaliyah",
  "Amira",
  "Nour",
  "Sana",
  "Leena",
  "Hiba",
  "Rania",
  "Lina",
  "Mariam",
  "Salma",
  "Noor",
  "Iman",
  "Jannah",
  "Yasmin",
  "Safa",
  "Zara",
  "Sumaya",
  "Ayat",
  "Huda",
  "Tala",
  "Lamia",
  "Bushra",
  "Nadia",
  "Ruqayyah",
  "Shazia",
  "Asma",
  "Hafiza",
  "Samira",
  "Suhaila",
  "Tamara",
  "Inaya",
  "Eman",
  "Rahma",
  "Sabrina",
  "Sakina",
  "Munira",
  "Thuraya",
  "Maha",
  "Mona",
  "Layla",
  "Nada",
  "Dina",
  "Shifa",
  "Tasneem",
  "Anaya",
  "Hidaya",
  "Farah",
  "Lubna",
  "Fariha",
  "Shamsa",
  "Zaina",
  "Nayla",
  "Hanan",
  "Jameela",
  "Arwa",
  "Shireen",
  "Nahla",
  "Amani",
  "Malika",
  "Lujain",
  "Yumna",
  "Sahar",
  "Ghazal",
  "Reem",
  "Laila",
  "Esra",
  "Rimsha",
  "Sadia",
  "Husna",
  "Rahaf",
  "Marwa",
  "Zohra",
  "Abeera",
  "Soumaya",
  "Taniya",
  "Nashwa",
  "Erum",
  "Zain",
  "Rim",
  "Asiya",
  "Hira",
  "Ruba",
  "Shahd",
  "Mina",
  "Areeba",
  "Sadiya",
  "Noureen",
  "Sameera",
  "Nuzhat",
  "Firdaus",
  "Ilham",
  "Rafiya",
  "Mahira",
  "Wasila",
];

// Array of dummy player pictures
const DUMMY_PLAYERS_PICTURE = [
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT9E09nnGyHTGXyYTGIKRFDTntCmSHse4cSHQ&s",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJbRXtxeNVzBQ64_E715LKeq50stz6nnmidA&s",
  "https://i.pinimg.com/736x/c6/bd/56/c6bd56fdee41076c706f92308a5a6804.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXgNDZxKgHxajQGNvbJ3DzRyL6cxZ08iCIaw&s",
  "https://static.toiimg.com/photo/108295369/108295369.jpg",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7Uv8Foc2ZC2lMAXTzJ3apmTaGeyPrd8Scgw&s",
  "https://img.indiaforums.com/person/480x360/1/3755-ayesha-singh.jpg?c=8uADC8",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSeoZOmIv2QE1QaKX-YPnYJR_RiIEkCrfkTbQ&s",
  "https://i.guim.co.uk/img/static/sys-images/Guardian/Pix/pictures/2014/12/8/1418005365663/6a60b5e8-1ada-4442-8719-e6da5472d36f-1020x701.jpeg?width=700&quality=85&auto=format&fit=max&s=60f16c5d89a4d0741358182d87e3b2fd",
  "https://i.pinimg.com/736x/9f/29/e0/9f29e0e7e3c93bed86b0c87fa6e8018f.jpg",
  "https://5.imimg.com/data5/SELLER/Default/2023/12/371357774/EM/MS/WD/104950264/dsc-7483-500x500.jpg",
  "https://i.pinimg.com/736x/55/f8/3e/55f83e5e61c78a27d00f43b892536950.jpg",
];

// Function to get a random dummy image
export const getRandomDummyImage = () => {
  return DUMMY_PLAYERS_PICTURE[
    Math.floor(Math.random() * DUMMY_PLAYERS_PICTURE.length)
  ];
};

// Function to get a random name from the list
export const getRandomDummyName = () => {
  return DUMMY_GIRL_NAMES[Math.floor(Math.random() * DUMMY_GIRL_NAMES.length)];
};

// Export arrays as well for flexibility
export { DUMMY_GIRL_NAMES, DUMMY_PLAYERS_PICTURE };

export default {
  DUMMY_GIRL_NAMES,
  DUMMY_PLAYERS_PICTURE,
  getRandomDummyImage,
  getRandomDummyName,
};
